// Port of api/fuel/app/classes/filter/search/users/sorts/query/name.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'name',
	post: false,
	require: function(config, filter) { return true },
	run: function(config, filter, data, query) {
		query.order('u.user_sortname', sortReverse('name', filter), sortPriority('name', filter, 1000))
	}
}
